import React from 'react';
import './CaseDetails.css';

const CaseDetails = ({ caseData, onBack }) => {
  if (!caseData) {
    return (
      <div className="case-details-container">
        <div className="case-details-header">
          <button className="back-button" onClick={onBack}>←</button>
          <h2>Case Details</h2>
        </div>
        <p>No case data available</p>
      </div>
    );
  }

  const proceedings = caseData.proceedings || [];

  return (
    <div className="case-details-container">
      <div className="case-details-header">
        <button className="back-button" onClick={onBack}>←</button>
        <h2>Case Details</h2>
      </div>

      <div className="case-details-content">
        {proceedings.length > 0 ? (
          <div className="proceedings-table-wrapper">
            <table className="proceedings-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Case Time</th>
                  <th>Note</th>
                  <th>Case title</th>
                  <th>Judge Name</th>
                </tr>
              </thead>
              <tbody>
                {proceedings.map((proceeding, index) => {
                  const proceedingDate = new Date(proceeding.datetime);
                  const formattedDate = proceedingDate.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                  });
                  const formattedTime = proceedingDate.toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true
                  });

                  return (
                    <tr key={proceeding.id || index}>
                      <td>{formattedDate}</td>
                      <td>{formattedTime}</td>
                      <td>{proceeding.note || '-'}</td>
                      <td>{caseData.caseType || caseData.title || '-'}</td>
                      <td>{proceeding.judge_name || 'N/A'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="no-proceedings">
            <p>No proceedings found for this case.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CaseDetails;
